import { Link, Navbar, NavbarBrand, NavbarContent, NavbarItem } from "@heroui/react";
import { useMemo } from "react";
import { useLocation } from "react-router";
import TurnstileLogoDark from "../assets/logo-dark.svg";
import AccountNavbarItem from "./AccountNavbarItem";
import { ActivityPanelNavbarItem } from "./ActivityPanelNavbarItem";

export default function NavbarComponent() {
  return (
    <Navbar maxWidth="2xl" height="100px" className="bg-[#193448] isolate">
      <NavbarBrand>
        <img src={TurnstileLogoDark} alt="Turnstile Logo" />
      </NavbarBrand>

      <NavbarContent justify="center">
        <NavLinkItem label="Bridge" href="/" />
        <NavLinkItem label="Transfers" href="/transfers" />
        <NavLinkItem label="Shielding" href="/shielding" />
        <NavLinkItem label="Tokens" href="/tokens" />
        <NavLinkItem label="Transactions" href="/transactions" />
      </NavbarContent>

      <NavbarContent justify="end">
        <ActivityPanelNavbarItem />
        <AccountNavbarItem />
      </NavbarContent>
    </Navbar>
  );
}

function NavLinkItem({ label, href }: { label: string; href: string }) {
  const location = useLocation();

  const isActive = useMemo(() => {
    return location.pathname === href;
  }, [location.pathname, href]);

  return (
    <NavbarItem isActive={isActive} className="turnstile-navbar-item text-medium font-semibold">
      <Link href={href} color="foreground" isBlock>
        {label}
      </Link>
    </NavbarItem>
  );
}
